<template>
  <div class="subtitle">
    <li class="kp-list-item dropdown" klickart-folder-item-type="klickart" role="tabpanel">
      <div class="kp-folder-name">
        <span>{{pageName}}</span>
      </div>
      <div class="kp-folder-updatedate">{{lastEditedAt}}</div>
      <span class="kp-select-open">
        <a :href="editorUrl">
          <i class="icon-kp-edit"></i>{{$t('analytics.header.subtitle.edit').toUpperCase()}}
        </a>
      </span>
    </li>
  </div>
</template>

<script>
import dateHelper from '@/services/date';
import EditorApi from '@/services/request/editorApiPage';
import rebrand from '../../../../config/rebrand';

export default {
  data() {
    return {
      pageName: '',
      lastEditedAt: '',
      editorUrl: `${rebrand.urls.KLICKART_URL}/crossapp/editor?redirect=${rebrand.urls.EDITOR_URL}/${this.$route.params.pageIdentifier}`,
    };
  },
  mounted() {
    const editorApi = new EditorApi();

    editorApi.page(`${this.$route.params.pageIdentifier}`)
      .then((response) => {
        this.pageName = response.data.name;
        this.lastEditedAt = dateHelper.formatedDate(response.data.updatedAt, this.$t('date.dateAndTime'));
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Layout/components/subtitle/NewEditorHeaderSubtitle.vue